export type PaymentProvider = "stripe" | "flutterwave" | "maishapay";

export interface User {
  id: string;
  country?: string | null;
}

const AFRICAN_COUNTRIES = new Set([
  "DZ", "AO", "BJ", "BW", "BF", "BI", "CM", "CV", "CF", "TD", "KM", "CG", "CD", "CI", "DJ",
  "EG", "GQ", "ER", "SZ", "ET", "GA", "GM", "GH", "GN", "GW", "KE", "LS", "LR", "LY", "MG",
  "MW", "ML", "MR", "MU", "MA", "MZ", "NA", "NE", "NG", "RW", "ST", "SN", "SC", "SL", "SO",
  "ZA", "SS", "SD", "TZ", "TG", "TN", "UG", "ZM", "ZW"
]);

const COUNTRY_ALIASES: Record<string, string> = {
  DRC: "CD",
  RDC: "CD",
  "DEMOCRATIC REPUBLIC OF CONGO": "CD",
  "CONGO DRC": "CD",
};

function normalizeCountry(country?: string | null): string | null {
  if (!country) return null;
  const value = country.trim().toUpperCase();
  if (value.length === 2) return value;
  return COUNTRY_ALIASES[value] || null;
}

export function getPaymentProvider(user: User): PaymentProvider {
  const country = normalizeCountry(user.country);
  if (!country) return "stripe";
  if (AFRICAN_COUNTRIES.has(country)) return "flutterwave";
  return "stripe";
}
